import { motion } from "framer-motion";
import { MapPin, CheckCircle2 } from "lucide-react";
import { STATE_ABBR, SYSTEM_STYLES } from "@/lib/stateMeta";

export function StateGrid({ states, onPick }) {
  return (
    <div>
      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-3" data-testid="state-grid">
        {states.map((s, i) => (
          <motion.button
            key={s.state}
            initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.3, delay: Math.min(i * 0.012, 0.4) }}
            onClick={() => onPick(s)}
            className="group relative text-left bg-white border border-saddle/20 hover:border-blaze hover:-translate-y-0.5 transition-[transform,border-color] duration-200 p-4 flex flex-col gap-2"
            data-testid={`state-card-${s.state}`}
          >
            <div className="flex items-center justify-between">
              <span className="font-serif text-2xl text-forest leading-none tabular-nums tracking-tight">{STATE_ABBR[s.state] || ""}</span>
              {s.has_data
                ? <CheckCircle2 size={16} className="text-[#2E7D46]" data-testid={`state-verified-${s.state}`} />
                : <MapPin size={15} className="text-saddle/40" />}
            </div>
            <span className="text-sm font-medium text-charcoal leading-tight">{s.state}</span>
            <span className={`inline-block w-fit text-[10px] font-semibold uppercase tracking-wide px-1.5 py-0.5 ${SYSTEM_STYLES[s.system] || SYSTEM_STYLES.otc_general}`}>
              {s.system_label}
            </span>
            <span className="text-[11px] text-charcoal/50 mt-auto">
              {s.has_data ? `${s.hunt_count} verified hunt${s.hunt_count === 1 ? "" : "s"}` : "Coverage in progress"}
            </span>
          </motion.button>
        ))}
      </div>
    </div>
  );
}
